/* eslint-disable @typescript-eslint/ban-ts-comment */
import DownloadPage from 'components/DownloadPage';
import { formatTime, I18nt } from 'utils';
import { useAgendarCita } from '../AgendarCitaContext';
import jsPDF from 'jspdf';
import I18n from 'i18n-js';
import moment from 'moment';

function ConfirmationView() {
	const {
    patient,
    dispatch,
    selectedTime,
    selectedDate,
    selectedClinic,
    selectedDoctor,
    selectedCategory,
    isSpecialist,
    citaId,
  } = useAgendarCita();
  const doc = new jsPDF({ format: 'letter' });

  const placeData = {
    ...(isSpecialist ? 
      {
        medico: selectedDoctor?.nombreMedico,
        lugar: selectedDoctor?.nombreEstablecimiento,
        especialidad: selectedCategory?.nombreEspecialidad,
      } : 
      {lugar: selectedClinic?.establecimiento}),
  };

	const data = {
		paciente: `${patient?.nombrePaciente} ${patient?.apellidoPaciente}`,
		numero_de_afiliación: patient?.numeroAfiliado,
		dui: patient?.dui,
		...placeData,
		fecha: moment(selectedDate, 'YYYY-MM-DD').format('DD-MM-YYYY'),
		hora: formatTime(selectedTime),
		...(patient?.email ? { email: patient?.email } : {}),
	};

	const printPdf = () => {
		let y = 40;
		doc.setFontSize(16);
		//@ts-ignore
		doc.text(I18nt('comprobante_de_cita'), 105, 30, null, null, 'center');
		doc.setFontSize(10);
		//@ts-ignore
		doc.text(I18nt('isbm'), 105, 35, null, null, 'center');
		doc.setFontSize(11);
		for (const key in data) {
			y += 7;
			//@ts-ignore
			doc.text(`${I18n.t(key)}: ${data[key]}`, 50, y, null, null, 'left');
		}
		doc.setFontSize(13);
		//@ts-ignore
		doc.text(`${I18n.t('indicaciones')}:`, 50, y + 14, null, null, 'left');
		doc.setFontSize(10);
		doc.text(
			`${I18n.t('pdf_instructions')}`,
			50,
			y + 21,
			null,
			null,
			//@ts-ignore
			'left'
		);
		doc.text(
			`${I18n.t('pdf_instructions2')}`,
			50,
			y + 28,
			null,
			null,
			//@ts-ignore
			'left'
		);
		doc.save(`comprobante_de_cita_${selectedDate}_${citaId}.pdf`);
	};

	return (
		<DownloadPage
			btnAction={printPdf}
			subTitle2='gracias_por_usar'
			text='si_deseas_tu_comprobante'
			downloadBtn='comprobante_de_cita'
			goBackText='calendarizacion_de_citas'
			goBackAction={() => dispatch({ type: 'reset' })}
			title={I18nt('tu_cita_ha_sido', {
				name: patient?.nombrePaciente || '',
			})}
		/>
	);
}

export default ConfirmationView;
